import Pluralize from 'pluralize';

// Metric and imperial unit abbreviations should not be pluralized
Pluralize.addUncountableRule('kg');
Pluralize.addUncountableRule('km');
Pluralize.addUncountableRule('lbs');

export default Pluralize;
